// Common gTLDs, ccTLDs, and multi-part public suffixes used for blocked-domain checks.
// Longer multi-part suffixes are listed first so matching prefers them.
const KNOWN_SUFFIXES = [
  // Multi-part / country second-level
  "co.uk",
  "org.uk",
  "ac.uk",
  "gov.uk",
  "me.uk",
  "net.uk",
  "sch.uk",
  "com.au",
  "net.au",
  "org.au",
  "edu.au",
  "gov.au",
  "co.nz",
  "org.nz",
  "net.nz",
  "govt.nz",
  "co.jp",
  "or.jp",
  "ne.jp",
  "ac.jp",
  "go.jp",
  "com.br",
  "com.cn",
  "com.mx",
  "com.sg",
  "com.hk",
  "com.tw",
  "co.in",
  "co.za",
  "co.kr",
  "com.tr",
  "com.ar",

  // Common generic / sponsored
  "com",
  "org",
  "net",
  "edu",
  "gov",
  "mil",
  "int",
  "io",
  "ai",
  "app",
  "dev",
  "cloud",
  "tech",
  "info",
  "biz",
  "name",
  "pro",
  "xyz",
  "online",
  "site",
  "store",
  "shop",
  "blog",
  "me",
  "tv",
  "cc",
  "co",
  "uk",
  "us",
  "ca",
  "au",
  "nz",
  "ie",
  "de",
  "fr",
  "es",
  "it",
  "nl",
  "be",
  "ch",
  "at",
  "se",
  "no",
  "dk",
  "fi",
  "pl",
  "pt",
  "cz",
  "sk",
  "hu",
  "ro",
  "bg",
  "gr",
  "tr",
  "ru",
  "ua",
  "in",
  "jp",
  "kr",
  "cn",
  "hk",
  "tw",
  "sg",
  "my",
  "id",
  "th",
  "ph",
  "vn",
  "br",
  "mx",
  "ar",
  "cl",
  "za",
  "ae",
  "sa",
  "il",
  "eu",
].sort((a, b) => b.length - a.length);

const DOMAIN_LABEL_PATTERN =
  /^[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?)+$/i;

export const normalizeDomain = (input = "") => {
  let value = String(input).trim().toLowerCase();

  value = value.replace(/^https?:\/\//i, "");
  value = value.replace(/^www\./i, "");
  value = value.split(/[/?#]/)[0];
  value = value.replace(/:\d+$/, "");
  value = value.replace(/\.+$/, "");

  return value;
};

export const hasKnownSuffix = (domain) =>
  KNOWN_SUFFIXES.some(
    (suffix) =>
      domain.endsWith(`.${suffix}`) && domain.length > suffix.length + 1
  );

export const validateDomain = (input) => {
  const domain = normalizeDomain(input);

  if (!domain) {
    return { ok: false, error: "Domain is required." };
  }

  if (domain.includes(" ")) {
    return { ok: false, error: "Domain cannot contain spaces." };
  }

  if (!DOMAIN_LABEL_PATTERN.test(domain)) {
    return {
      ok: false,
      error: "Enter a valid domain (e.g. example.com).",
    };
  }

  if (!hasKnownSuffix(domain)) {
    return {
      ok: false,
      error: "Domain must end with a known suffix (e.g. .com, .co.uk, .org).",
    };
  }

  return { ok: true, domain };
};
